<script setup>
import { useRoute } from 'vue-router';
import AuthorBox from '../components/tradingroom/AuthorBox.vue';
import { store } from '../store.js';
import { onMounted, ref } from 'vue';

const author = ref(null);
const authors = ref([]);
const loading = ref(false);

const route = useRoute();

onMounted(async () => {
    await fetchAuthors();
    author.value = authors.value.find((author) => author.author === route.params.author);
});
const fetchAuthors = async () => {
    loading.value = true;
    try {
        await store.dispatch('authors/index');
        authors.value = store.getters['authors/all'];
    } catch (error) {
        console.error('Error loading team data:', error);
    } finally {
        loading.value = false;
    }
};
</script>

<template>
    <div class="contianer mx-auto py-32">
        <div v-if="author">
            <div>
                <AuthorBox :name="author.author" preview :authors="authors" />
            </div>
        </div>
        <div v-else>
            <h1>Author not found</h1>
        </div>
    </div>
</template>
